import { Button } from "PFComponents/button";
import { Select } from "PFComponents/select";
import { fetchAutocompleteSkills } from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";
import { Experience, PureCustomValueCamelCased } from "PFCore/types";
import { Option } from "PFTypes/options";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useFeedbackFormMutations } from "../../hooks/use_feedback_form";
import css from "./skills_evaluation.module.scss";
import { SkillsTable } from "./skills_table";

type SkillsEvaluationProps = {
  readOnly: boolean;
};

export const SkillsEvaluation = ({ readOnly }: SkillsEvaluationProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.feedback" });
  const { addSkill, isSkillInForm } = useFeedbackFormMutations();
  const [showNewSkillField, setShowNewSkillField] = useState(false);

  if (readOnly) {
    return <SkillsTable readOnly={readOnly} />;
  }

  const onAddSkill = ({ original: skill }: Option<PureCustomValueCamelCased>) => {
    addSkill({
      ...skill,
      text: String(skill.text || ""),
      name: String(skill.text || ""),
      experience: Experience.None
    });
    setShowNewSkillField(false);
  };

  return (
    <div>
      <SkillsTable />
      {showNewSkillField ? (
        <Select<PureCustomValueCamelCased>
          fetchOptions={({ searchTerm }) =>
            fetchAutocompleteSkills({ term: searchTerm || "" })
              .then((skills) => skills.filter((skill) => !isSkillInForm(skill)))
              .then((skills) => ({
                entries: skills.map((skill) => ({
                  id: skill.id,
                  value: String(skill.id),
                  displayElement: skill.text,
                  original: skill
                })),
                meta: { total: skills.length }
              }))
          }
          onChange={onAddSkill}
          className={css.addSkill}
        />
      ) : (
        <Button
          icon="add"
          text={t("addSkill")}
          kind="text"
          onClick={() => setShowNewSkillField(true)}
          className={css.addSkill}
        />
      )}
    </div>
  );
};
